import React, { useState, useEffect, Fragment } from 'react';
import {
  Row,
  Input,
  FormGroup,
  CustomInput,
  Button,
  ButtonGroup,
  Form,
  Modal,
  ModalBody,
  InputGroup,
  Label
} from 'reactstrap';
import {
  Colxx,
  Separator,
} from '../../../../../components/common/CustomBootstrap';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';

import {
  gAPI_Property_List_By_Group,
  postAPI_Create_RevinateIntegration,
  gAPI_Ingetration,
  putAPI_Update_RevinateIntegration,
} from '../../../../../constants/APIs';
import short from 'short-uuid';
import Axios from 'axios';
import Validation from '../../../../../components/Validation';

let arr = [];
export default function RevinateIntegration({ visible, toggle, id }) {
  const [property, setProperty] = useState([]);
  const [open, setOpen] = useState(false);
  const [msg, setMsg] = useState([]);
  const [selectedproperty, setSeletedProperty] = useState([]);
  const [inputData, setInputData] = useState({
    GroupId: getGroupID(),
    Name: '',
    Properties: [],
    SessionTimeoutInSeconds: 600,
    DefaultLanguage: 'en-US',
    ApiKey: '',
    MarketConsent: false
  });

  useEffect(() => {
    //console.log(id);
    if (id !== undefined) {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Ingetration}/${id}?group_id=${getGroupID()}`,
      })
        .then((res) => {
          // console.log(res.data)
          let filterList = [];
          if (res.data.properties !== null) {
            filterList = res.data.properties.filter(
              (elem) => elem !== undefined || null
            );
          }
          setSeletedProperty(filterList);
          // console.log(filterList);         
          setInputData({
            ...inputData,
            Name: res.data.name,
            ApiKey: res.data.channelDetails.apiKey,
            Properties: filterList,
            MarketConsent: res.data.channelDetails.marketConsent
          });
        })
        .catch((err) => console.log('err', err));

      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    } else {
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Property_List_By_Group}/?group_id=${getGroupID()}`,
      })
        .then((res) => {
          setProperty([...res.data]);
        })
        .catch((err) => console.error(err));
    }
  }, [id]);

  const handleNameChange = (e) => {
    e.persist();
    setInputData({ ...inputData, Name: e.target.value });
  };

  const handleApiKeyChange = (e) => {
    e.persist();
    setInputData({ ...inputData, ApiKey: e.target.value });
    console.log(inputData);
  };

  const handleCheckChange = (e) => {
    console.log(e.target.value);
    if (
      selectedproperty.includes(e.target.value) &&
      selectedproperty.length > 0
    ) {
      let itemsList = selectedproperty.filter(
        (item) => item !== e.target.value || null || undefined
      );
      setSeletedProperty(itemsList);
      setInputData({ ...inputData, Properties: itemsList });
    } else {
      let lengthArry = selectedproperty.length;
      selectedproperty[lengthArry] = e.target.value;
      setSeletedProperty(selectedproperty);
      setInputData({ ...inputData, Properties: selectedproperty });
    }
  };

  const handleSave = async () => {
    if (id !== undefined) {
      AxiosAPI({
        method: 'put',
        url: `${putAPI_Update_RevinateIntegration}/${id}?group_id=${getGroupID()}`,
        data: inputData,
      }).then((res) => {
        if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
          && res.data.Messages !== null && res.data.Messages.length > 0) {
          setMsg(res.data.Messages);
          setOpen(true);
        }
        else {
          toggle();
          setTimeout(() => {
            window.location.reload();
          }, 300);
        }
      });
    } else {
      AxiosAPI({
        method: 'post',
        url: postAPI_Create_RevinateIntegration,
        data: inputData,
      }).then((res) => {
        if (res.data.HttpStatusCode !== undefined && res.data.HttpStatusCode === 400 && res.data.Messages !== undefined
          && res.data.Messages !== null && res.data.Messages.length > 0) {
          setMsg(res.data.Messages);
          setOpen(true);
        }
        else {
          toggle();
          setTimeout(() => {
            window.location.reload();
          }, 300);
        }
      });
    }
  };
  return (
    <Fragment>
      <Modal isOpen={visible} toggle={toggle}>
        <ModalBody>
          <Row className="mb-4">
            <Colxx xxs="12">
              <div className="text-center">
                <h6>{id === undefined ? "Add" : "Update"}  Integration</h6>
                <Separator className="mb-3" />
                <Form autoComplete="off">
                  <FormGroup className="mb-2 text-left">
                    <Label>Integration Name</Label>
                    <Input
                      type="text"
                      name="integrationName"
                      onChange={handleNameChange}
                      placeholder="Integration Name"
                      defaultValue={inputData.Name}
                    />
                  </FormGroup>
                  <FormGroup>
                    <div className='integration-property'>
                      {property.map((p, index) => {
                        return (
                          <CustomInput
                            key={p.id}
                            type="checkbox"
                            id={index}
                            label={p.name}
                            value={p.id}
                            onChange={handleCheckChange}
                            checked={
                              inputData.Properties.includes(p.id) ? true : false
                            }
                          />
                        );
                      })}
                    </div>
                  </FormGroup>
                  <FormGroup className="mb-2 text-left">
                    <Label>Api Key</Label>
                    <Input
                      type="text"
                      name="apikey"
                      onChange={handleApiKeyChange}
                      placeholder="API Key"
                      defaultValue={inputData.ApiKey}
                    />
                  </FormGroup>
                  <FormGroup>
                    <CustomInput
                      type="checkbox"
                      id="giftEnabled"
                      checked={inputData.MarketConsent}
                      label="Save contact only when visitor gave consent"
                      name="giftEnabled"
                      onChange={(e) =>
                        setInputData({ ...inputData, MarketConsent: e.target.checked })
                      }
                    />
                  </FormGroup>
                </Form>

                <ButtonGroup className="mb-2" style={{ marginTop: '20px' }}>
                  {id === undefined ? (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Create New Integration
                    </Button>
                  ) : (
                    <Button color="primary" size="xs" onClick={handleSave}>
                      Update Integration
                    </Button>
                  )}

                  <Button size="xs" color="dark" outline onClick={toggle}>
                    Cancel
                  </Button>
                </ButtonGroup>
              </div>
            </Colxx>
          </Row>
        </ModalBody>
      </Modal>
      <Validation open={open} messages={msg} toggle={() => { setOpen(!open) }}></Validation>
    </Fragment>
  );
}
